import { useState } from "react";
import RmaForm from "../components/rma-form/RmaForm";
import LoadingSpinner from "../components/common/LoadingSpinner";

const RmaView: React.FC = () => {
    return <RmaForm />;
};

export default RmaView;
